import React, { PureComponent, Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { Row, Card, CardBody } from 'reactstrap';
import { Colxx, Separator } from 'Components/CustomBootstrap';
import Pluralize from 'react-pluralize';
import ReactTable from 'react-table';
import BreadcrumbContainer from 'Components/BreadcrumbContainer';
import DataTablePagination from 'Components/DataTables/pagination';
import IntlMessages from 'Util/IntlMessages';
import {
	paymentMethodsFindAll,
	errorReset,
} from 'Redux/actions';
import * as paymentMethodsReducer from 'Redux/paymentMethods/reducer';

class PagePayments extends PureComponent {
	constructor() {
		super();
		this.breadcrumb = [
			{ id: 'menu.payment', href: '/payment/list' },
		];
		this.columns = [
			{
				id: 'pay_seq',
				Header: 'Seq',
				accessor: 'pay_seq',
				width: 50,
			},
			{
				id: 'name',
				Header: 'Payment Name',
				accessor: (d) => (
					<NavLink to={`/app/payment/edit/${d.code}`}>
						{
							d.pay_icon ? (
								<img
									src={`data:image/png;base64,${d.pay_icon}`}
									className="icon mr-3"
								/>
							) : (
								<div className="icon mr-3 d-inline-block">&nbsp;</div>
							)
						}
						<span className="list-item-heading mb-1 truncate">{d.description}</span>
					</NavLink>
				),
			},
			{
				id: 'code',
				Header: 'Code / Is Cash',
				accessor: (d) => {
					let ret = `${d.code} / `;
					switch (d.is_cash) {
					case 'C': ret += 'C - Credit Card'; break;
					case 'D': ret += 'D - Cash Deposit'; break;
					case 'N': ret += 'N - Non Cash'; break;
					case 'O': ret += 'O - Cash Coupon'; break;
					case 'W': ret += 'W - Manual ECR'; break;
					case 'Y': ret += 'Y - Cash'; break;
					}
					return ret;
				},
			},
			{
				id: 'warehouses',
				Header: 'Applied',
				sortable: false,
				accessor: (d) => (
					d.warehouses ? (
						<Pluralize singular="Shop" count={d.warehouses.length} />
					) : (
						'N/A'
					)
				),
			},
			{
				id: 'shop_show',
				Header: 'Show in Shop',
				accessor: (d) => {
					switch (d.shop_show) {
					case 'Y':
						return 'Yes';
					case 'N':
						return 'No';
					default:
						return d.shop_show;
					}
				},
			},
			{
				id: 'status',
				Header: 'Status',
				accessor: (d) => {
					switch (d.status) {
					case 'A':
						return 'Active';
					case 'I':
						return 'Inactive';
					default:
						return d.status;
					}
				},
			},
			{
				id: 'updated_on',
				Header: 'Updated On',
				accessor: 'updated_on',
			},
			{
				id: 'updated_by',
				Header: 'Updated By',
				accessor: 'updated_by',
			},
			{
				id: 'action',
				Header: '',
				width: 50,
				accessor: (d) => (
					<NavLink className="btn btn-xs btn-outline-primary" to={`/app/payment/edit/${d.code}`}>
						<i className="simple-icon-pencil" />
					</NavLink>
				)
			},
		];
		this.fetchData = this.fetchData.bind(this);
	}

	componentDidMount() {
		this.fetchData();
		this.props.errorReset('paymentMethods');
	}

	fetchData() {
		this.props.paymentMethodsFindAll();
	}

	render() {
		const { paymentMethods } = this.props;
		const status = this.props.status.get('paymentMethods');
		return (
			<Fragment>
				<Row>
					<Colxx xxs="12">
						<div className="float-left">
							<BreadcrumbContainer
								heading={<IntlMessages id="payments.heading" />}
								items={this.breadcrumb}
								match={this.props.match}
							/>
						</div>
						<div className="float-right">
							<NavLink to="/app/payment/create" className="btn btn-lg btn-primary">
								CREATE NEW
							</NavLink>
						</div>
					</Colxx>
				</Row>

				<Separator className="mb-5" />

				<div className="text-right mb-3">

				</div>

				<Row>
					<Colxx xxs="12">
						<Card>
							<CardBody>
								<ReactTable
									data={paymentMethods.toJS()}
									loading={status === 'fetching'}
									columns={this.columns}
									minRows={0}
									showPageJump={true}
									showPageSizeOptions={true}
									PaginationComponent={DataTablePagination}
								/>
							</CardBody>
						</Card>
					</Colxx>
				</Row>
			</Fragment>
		);
	}
}

export default connect(
	paymentMethodsReducer.selector,
	{
		paymentMethodsFindAll,
		errorReset,
	}
)(PagePayments);
